<template>
	<pagina-erro
		titulo="Atualização Cadastral Encerrada"
		icone="fa fa-hourglass-end"
		imagemTexto="centralservidor-logo-texto.png"
		imagem="centralservidor-logo.png"
		texto="O período de atualização cadastral se encerrou.
			Caso ainda precise atualizar seus dados, dirija-se ao DEGEPAT." >
	</pagina-erro>
</template>

<script >
import PaginaErro from '@/components/pagina-erro'

export default {
	name: 'Encerrado',
	components: {
		PaginaErro
	}
}
</script>




// WEBPACK FOOTER //
// index.vue?259437f0